// extracted by mini-css-extract-plugin
export default {"content-wrapper":"ajZW9","title":"TkTin"};